module.exports = __webpack_public_path__ + "img/traffic7.bee78f22.png";